import React, { useMemo } from 'react';
import { useTranslation } from '@shared/core';
import { Flex } from '@withjoy/joykit';
import { TravelMapBlockType } from '../../Accommodations.types';

export const CardTag = ({ isFavorite, type }: { isFavorite?: boolean | null; type: TravelMapBlockType }) => {
  const { t } = useTranslation('websiteEditor');
  const hotelTrans = t('customPage', 'travelMap', 'hotel');
  const labels = useMemo(() => {
    const labelsToShow = [];
    if (isFavorite) {
      labelsToShow.push({
        text: hotelTrans.labelFavorite(),
        textColor: '#595959',
        bgColor: '#FFF3E5',
        borderColor: '#F9B686',
      });
    }

    if (type === TravelMapBlockType.travelMapAccommodationsRoomblock) {
      labelsToShow.push({
        text: hotelTrans.labelRoomblock(),
        textColor: 'white',
        bgColor: '#333333',
      });
    }

    return labelsToShow;
  }, [hotelTrans, isFavorite, type]);

  return (
    <>
      {!!labels?.length && (
        <Flex
          position="relative"
          gap={4}
          alignItems="center"
          width="100%"
          className="tags"
          marginBottom={1}
        >
          {labels.map((l, i) => (
            <Flex
              key={i}
              typographyVariant={'label3'}
              fontWeight={'bold'}
              borderRadius={50}
              border={'1px solid'}
              borderColor={l.borderColor}
              backgroundColor={l.bgColor}
              color={l.textColor}
              gap={3}
              paddingY={1}
              paddingX={4}
            >
              {l.text}
            </Flex>
          ))}
        </Flex>
      )}
    </>
  );
};
